module.exports = __webpack_public_path__ + "img/agentbox.7fe19171.png";